const $inject = ['$scope', '$routeParams', 'dataService'];

const lbaFeatureSelectCtrl = function($scope, $routeParams, dataService) {
  const vm = this;
  const dataLookUp = dataService.spiltDataAt(vm.settings.dataAt, $routeParams);
  const data = _.get(dataService.data.activeItem, dataLookUp);

  vm.data = data ? { Name: data } : null;

  vm.refreshData = refreshData;

  $scope.$watchCollection('vm.data', (newData, oldData) => {
    if (newData !== oldData) {
      _.set(dataService.data.activeItem, dataLookUp, newData)
    }
  });

  function refreshData(userSearch) {
    if (userSearch && userSearch.length > 1) {
      dataService.search({
        endpoint: 'FeatureFlags/Default.GetAvailableFeatures',
        searchTerm: userSearch,
        searchType: 'Name',
        expression: 'contains',
        includeDeleted: false,
        selectFields: 'Name',
        limit: 10,
        sort: 'Name'
      })
        .then((data) => {
          vm.searchResults = data;
        })
        .catch(() => {

        });
    }
  }
};

lbaFeatureSelectCtrl.$inject = $inject;

export default lbaFeatureSelectCtrl;


// WEBPACK FOOTER //
// ./src/components/lbaFeatureSelect/lbaFeatureSelectCtrl.js